export default __webpack_public_path__ + "5ed57af967e27fd53dd1ac082e7cfd8f.png";